export const NAME = 'employee'

export const WAITER_GET_BUNDLES = 'WAITER_GET_BUNDLES'
export const WAITER_GET_EMPLOYEE = 'WAITER_GET_EMPLOYEE'
export const WAITER_GET_EMPLOYEE_BENEFITS = 'WAITER_GET_EMPLOYEE_BENEFITS'
export const WAITER_GET_ENROLLMENTS = 'WAITER_GET_ENROLLMENTS'
export const WAITER_PUT_BENEFIT = 'WAITER_PUT_BENEFIT'
